import styled from '@emotion/styled'
export const StyleWrapper = styled.div`
  width: 300px;
  border-right: 1.5px solid ${(props: any) => props.theme.colors.inputBorder};
  @media (max-width: 767px) {
    width: 100%;
    border-right: 0px;
  }
`
